import { ErrorFallback } from "@/ErrorHandling/ErrorFallback";
import { createRichError, isMultipleAPIErrors, isSingleAPIError } from "@/ErrorHandling/utils";
import { captureException } from "@sentry/react";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

export const ErrorBoundaryWrapper: React.FC = () => {
  const { t } = useTranslation();

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error: Error, errorInfo: React.ErrorInfo) => {
        // Large inconsistencies in how errors are raised across the application
        // Need to check between API errors and other errors
        const isApiError = isMultipleAPIErrors(error) || isSingleAPIError(error);
        const errorForSentry = isApiError ? createRichError(error, errorInfo, t) : error;
        captureException(errorForSentry);
      }}
    >
      <Outlet />
    </ErrorBoundary>
  );
};
